import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities, loading = false }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'upload':
        return { name: 'Upload', color: 'text-primary' };
      case 'processed':
        return { name: 'CheckCircle', color: 'text-success' };
      case 'reviewed':
        return { name: 'Eye', color: 'text-accent' };
      case 'exported':
        return { name: 'Download', color: 'text-secondary' };
      case 'error':
        return { name: 'AlertCircle', color: 'text-error' };
      default:
        return { name: 'Activity', color: 'text-muted-foreground' };
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return time?.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Recent Activity</h3>
        <div className="space-y-4">
          {[...Array(5)]?.map((_, index) => (
            <div key={index} className="flex items-start space-x-3 animate-pulse">
              <div className="w-8 h-8 bg-muted rounded-full" />
              <div className="flex-1 space-y-2">
                <div className="w-3/4 h-4 bg-muted rounded" />
                <div className="w-1/2 h-3 bg-muted rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-smooth">
          View all
        </button>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) => {
          const iconConfig = getActivityIcon(activity?.type);
          
          return (
            <div key={activity?.id} className="flex items-start space-x-3 group">
              <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0`}>
                <Icon 
                  name={iconConfig?.name} 
                  size={16} 
                  className={iconConfig?.color}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground group-hover:text-primary transition-smooth">
                  {activity?.message}
                </p>
                <div className="flex items-center space-x-2 mt-1">
                  <span className="text-xs text-muted-foreground">
                    {formatTimeAgo(activity?.timestamp)}
                  </span>
                  {activity?.user && (
                    <>
                      <span className="text-xs text-muted-foreground">•</span>
                      <span className="text-xs text-muted-foreground">
                        {activity?.user}
                      </span>
                    </>
                  )}
                </div>
                
                {activity?.details && (
                  <div className="mt-2 p-2 bg-muted/50 rounded text-xs text-muted-foreground">
                    {activity?.details}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeed;